import { useCallback, useEffect } from 'react';
import Player from '../../360player';

const DEFAULT_VT_OPTIONS = {
  showLinkedCameras: true,
  showHotspots: true,
};

let PLAYER_LOADED = false;

export default function useVTController ({ selectedHome, setState, vtSceneData, configLoaded, logEventRef }) {
  // Initialize the virtual tour player on startup.
  // We will keep the VT player canvas hidden until we are ready to show it.
  useEffect(() => {
    if (configLoaded && !PLAYER_LOADED) {
      PLAYER_LOADED = true;
      window.player = new Player('renderCanvas', DEFAULT_VT_OPTIONS);

      window.player.onCameraNavigated = () => {
        console.group();
        console.log('VT: camera navigation complete');
        // eslint-disable-next-line
        const vtSceneData = window.player.getSceneData();
        setState(prevState => ({
          ...prevState,
          vtSceneData,
        }));
      }

      window.player.onHotspotClicked = (hotspotId, propInfo) => {
        setState(prevState => {
          return {
            ...prevState,
            vtSelectedHotspot: { hotspotId, propInfo },
          };
        });
        console.log('VT: hotspot clicked', hotspotId, propInfo);
      }
	  }
  }, [setState, configLoaded]);

  // Preload the virtual tour whenever the selected home changes
  useEffect(() => {
    if (window.player && selectedHome) {
      const tour = selectedHome.tour?.json || selectedHome.tour.url;
      console.group();
      console.log('VT: loading tour:', tour);
      window.player.load(tour, () => {
        console.log('VT: load tour complete', tour);
        // eslint-disable-next-line
        const vtSceneData = window.player.getSceneData();
        setState(prevState => ({
          ...prevState,
          vtSceneData,
        }));
        //  // We want to initialize the VT player to the frontyard camera if available.
        // DISABLING FOR NOW AS WE ARE GOING WITH 2-D IMAGE FOR FRONTYARD
        //  const frontyardZone = vtSceneData.find(zone => zone.type === 'frontyard');
        //  if (frontyardZone) {
        //    const bResetToOriginalRotation = false;
        //    window.player.moveToZone(frontyardZone.name, bResetToOriginalRotation);
        //  }
      }, logEventRef.current);
	  }
  }, [selectedHome, setState, logEventRef]);

  // Logic for updating the derived VT state when the scene data changes.
  useEffect(() => {
    const currentZone = vtSceneData?.find?.(zone => zone.isCurrent);
    const vtCurrentZoneName = currentZone?.name || '';
    const currentRoom = currentZone?.rooms?.find?.(room => room.isCurrent);
    const vtCurrentRoomName = currentRoom?.name || '';
    const vtCurrentCameraName = window?.player?.getCurrentCamera?.()?.name || '';
    const vtCurrentProducts = currentRoom?.perCameraProducts?.[vtCurrentCameraName] || [];
    const vtHasInteriorZones = !!(vtSceneData?.find?.(zone => !zone.isExterior) || false);

    setState(prevState => ({
      ...prevState,
      vtCurrentCameraName,
      vtCurrentProducts,
      vtCurrentRoomName,
      vtCurrentZoneName,
      vtHasInteriorZones,
    }));
    console.log('sceneData updated =', vtSceneData);
    console.log('current zone = ', vtCurrentZoneName);
    console.log('current room = ', vtCurrentRoomName);
    console.log('current camera =', vtCurrentCameraName);
    console.log('current products =', vtCurrentProducts);
    console.groupEnd();
  }, [setState, vtSceneData]);

  // Callback for moving to a specific Zone
  const moveToZone = useCallback(
    (strZoneName, bResetToOriginalRotation = false) => {
      window?.player?.moveToZone(strZoneName, bResetToOriginalRotation);
    },
    []
  );

  // Callback for moving to a specific Room
  const moveToRoom = useCallback(
    (strRoomName, bResetToOriginalRotation = false) => {
      window?.player?.moveToRoom(strRoomName, bResetToOriginalRotation);
    },
    []
  );

  return {
    moveToRoom,
    moveToZone,
  };
}
